export const getLocaleKey = () => {
    return navigator.language.slice(0, 2);
}